export var MessageDialogButtons;
(function (MessageDialogButtons) {
  MessageDialogButtons[MessageDialogButtons["OK"] = 1] = "OK";
  MessageDialogButtons[MessageDialogButtons["CANCEL"] = 2] = "CANCEL";
})(MessageDialogButtons || (MessageDialogButtons = {}));
;
/**
 * Open the modal dialog passed as parameter, adding a shaded backdrop
 * @param child - The content of dialog
 * @return the backdrop element, which should have its `close`
 *    callback set for when the user clicks on the backdrop
 */
export function openDialog(child) {
  const retv = document.createElement('modal-backdrop');
  retv.appendChild(child);
  document.body.appendChild(retv);
  return retv;
}
;
export function messageDialog(opts) {
  var _a;
  const messageDialog = document.createElement('message-dialog');
  if (opts.graphQLError) {
    opts.header = 'GraphQL API Error';
    let body = [];
    if (opts.graphQLError.errors) {
      for (var e of opts.graphQLError.errors) {
        let b = [];
        b.push('<b>Code</b>: ' + ((_a = e.extensions) === null || _a === void 0 ? void 0 : _a.code));
        b.push('<b>Path</b>: ' + e.path.join('/'));
        b.push(`<b>Message</b>: <code><verbatim>${e.message}</verbatim></code>`);
        body.push(b.join('<br/>'));
      }
    }
    else {
      opts.header = 'Request Exception';
      body.push(opts.graphQLError.exception);
    }
    opts.body = body;
    opts.buttons = MessageDialogButtons.OK;
  }
  opts.header && (messageDialog.header = opts.header);
  opts.body && (messageDialog.body = opts.body);
  opts.buttons && (messageDialog.buttons = opts.buttons);
  const modal = openDialog(messageDialog);
  messageDialog.modal = modal;
  return new Promise((resolve, _) => {
    messageDialog.responseCallback = resolve;
    modal.closeInterrupt = () => {
      resolve(MessageDialogButtons.CANCEL);
      return false;
    };
  });
}
